import { WORKOUT_FILTER_COUNT } from './actionTypes'

export default (filters) => ({
  type: WORKOUT_FILTER_COUNT,
  payload: {
    filters
  }
})